import React from 'react';
import PropTypes from 'prop-types';

import Link from '../../../../../../library/link/link';
import { AngleRightLightIcon } from '../../../../../../shared/icons/icons';

import styles from './cms-featured-article.scss';

function CmsFeaturedArticle(props) {
  const { description, heading, id, image, isFixedWidth, link } = props;

  return (
    <article
      className={
        isFixedWidth
          ? `${styles['article']} ${styles['article-fixed']}`
          : styles['article']
      }
      id={id}
    >
      <img
        alt={image?.altText}
        className={styles['image']}
        draggable="false"
        src={image?.url}
      />
      <div className={styles['info']}>
        <h3 className={styles['heading']}>{heading}</h3>
        <p className={styles['description']}>{description}</p>

        <Link className={styles['link']} to={link.href}>
          {link.text}
          <AngleRightLightIcon className={styles['icon']} />
        </Link>
      </div>
    </article>
  );
}

CmsFeaturedArticle.propTypes = {
  description: PropTypes.string,
  heading: PropTypes.string,
  id: PropTypes.string,
  image: PropTypes.object,
  isFixedWidth: PropTypes.bool,
  link: PropTypes.object
};

export default CmsFeaturedArticle;
